import { Helmet } from 'react-helmet';

const PageHelmet = ({ 
  title, 
  description, 
  keywords, 
  image = "/favicon.png",
  url = "https://rubaai.net"
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${url}${image}`} />
      <meta property="og:url" content={url} />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${url}${image}`} />
      
      {/* Additional Meta Tags to ensure proper override */}
      <meta name="application-name" content="Rubaai" />
      <meta name="msapplication-TileColor" content="#000000" />
    </Helmet>
  );
};

export default PageHelmet; 